import React, { useEffect } from 'react';
import HomeHero from '../components/home/HomeHero';
import ServiceHighlights from '../components/home/ServiceHighlights';
import AboutPreview from '../components/home/AboutPreview';
import WorkProgress from '../components/home/WorkProgress';
import ServiceSlider from '../components/home/ServiceSlider';
import ClientLogos from '../components/home/ClientLogos';
import { setPageTitle } from '../utils/helpers';
import ErrorBoundary from '../components/common/ErrorBoundary';
import Partners from '../components/home/Partners';

const Home = () => {
  useEffect(() => {
    // Set page title when component mounts
    setPageTitle('Custom Software Development Company in Houston Texas');
    
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <ErrorBoundary> {/* Wrap the entire component with ErrorBoundary */}
    <div className="home-page">
      <HomeHero />
      <ServiceHighlights />
      <AboutPreview />
      <WorkProgress />       
      <ServiceSlider />
      <Partners />
      <ClientLogos />
    </div>
    </ErrorBoundary>
  );
};

export default Home;